// Copyright (c) 2025 ParkEngage Inc. All rights reserved.

// This software is the confidential and proprietary information of
// ParkEngage Inc. ("Confidential Information"). You shall not
// disclose such Confidential Information and shall use it only in
// accordance with the terms of the license agreement you entered into
// with ParkEngage Inc.

// This source code is a valuable trade secret of ParkEngage Inc.

// THIS SOFTWARE IS PROVIDED BY ParkEngage Inc. ``AS IS'' AND ANY
// EXPRESS OR IMPLIED WARRANTIES, INCLUDING, BUT NOT LIMITED TO, THE
// IMPLIED WARRANTIES OF MERCHANTABILITY AND FITNESS FOR A PARTICULAR
// PURPOSE ARE DISCLAIMED. IN NO EVENT SHALL [YOUR COMPANY NAME] OR
// CONTRIBUTORS BE LIABLE FOR ANY DIRECT, INDIRECT, INCIDENTAL, SPECIAL,
// EXEMPLARY, OR CONSEQUENTIAL DAMAGES (INCLUDING, BUT NOT LIMITED TO,
// PROCUREMENT OF SUBSTITUTE GOODS OR SERVICES; LOSS OF USE, DATA, OR
// PROFITS; OR BUSINESS INTERRUPTION) HOWEVER CAUSED AND ON ANY THEORY
// OF LIABILITY, WHETHER IN CONTRACT, STRICT LIABILITY, OR TORT
// (INCLUDING NEGLIGENCE OR OTHERWISE) ARISING IN ANY WAY OUT OF THE USE
// OF THIS SOFTWARE, EVEN IF ADVISED OF THE POSSIBILITY OF SUCH DAMAGE.

// The views and conclusions contained in the software and documentation
// are those of the authors and should not be interpreted as representing
// official policies, either expressed or implied, of ParkEngage Inc.

import React, { useEffect, useState } from 'react'
import PropTypes from 'prop-types'
import noop from 'lodash/noop'
import { connect } from 'react-redux'
// import moment from 'moment-timezone'
import { EMPTY_ARRAY, EMPTY_OBJECT, driverArray, createDefaultVehicle } from '../../../constants/globalConstants'
import { isLoggedIn, isPermissionExist, restrictInValidCharLicense, restrictSpecialChar, sortPortalPermissionByKey, isVehicleLimitExceeded } from '../../../utils/helper'
// AllowededTime
import { getFacilityList, permitRateList } from '../../../redux/actions/BasicInfoAction'
// import { Circles } from 'react-loader-spinner'
// import FileUpload from '../../../components/fileUpload/FileUpload'
import { getVehicleDataList, getVehicleModelList } from '../../../redux/actions/VehicleListAction'
import './home.scss'
import { useNavigate, useParams } from 'react-router-dom'
import URL from '../../../constants/urls'
// import debounce from 'lodash/debounce'
// import DatePicker from 'react-datepicker'
import 'react-datepicker/dist/react-datepicker.css'
// import moment from 'moment'
import { MultiSelectInput, TextInput } from '../../../Global/Form'

function Driver(props) {
	const { setPage, dispatch,
		formData, setFormData, formError, partnerDetails,
		vehicleListArray,
		setVehicleListArray,
		setvehicleCount,
		vehicleCount,
		VehiclePrev,
		notify,
		setFormError,
		setMainVehicleMakeList,
		selectedVehicleList,
		setSelectedVehicleList
	} = props
	const { facility } = useParams()

	// const [resident, setResident] = useState()
	const [faclityList, setFaclityList] = useState(EMPTY_ARRAY)
	const [selectedFaclity, setSelectedFacilty] = useState(EMPTY_ARRAY)
	const [permitList, setPermit] = useState(EMPTY_ARRAY)
	// const [permitRateError, setPermitRateError] = useState('')
	// const [idErrProof, setIdErrProof] = useState({})
	const partner = window.location.toString().split('/')[3]
	const promotion = window.location.toString().split('/')[4]
	// const [showRemoveButton, setRemoveButtonShowKey] = useState('')
	const [error, setError] = useState(false)
	const [accessPermissions, setAccessPermissions] = useState('')


	// vehicle
	// const [isVehicleTableVisible, setIsVehicleTableVisible] = useState(false)
	// const [vehicleList, setVehicleList] = useState(EMPTY_ARRAY)
	const [vehicleDetailsList, setVehicleDetailsList] = useState(EMPTY_ARRAY)
	const [vehicleMakeList, setVehicleMakeList] = useState(EMPTY_ARRAY)
	const [vehicleModelList, setvehicleModelList] = useState(EMPTY_ARRAY)
	const [vehicleCountList, setvehicleCountList] = useState(EMPTY_ARRAY)
	const [driverList, setdriverList] = useState(driverArray)

	// const zoneList = [{ val: 'A', name: 'A' }, { val: 'B', name: 'B' }, { val: 'C', name: 'C' }]


	// for disbaled functionallty 
	// const [loginData, setLoginData] = useState(EMPTY_OBJECT)

	// to show the model in vehicle 
	const [is_modal_show, setIsShowModalInVehicle] = useState(false)
	const navigate = useNavigate()

	const searchParams = new URLSearchParams(location.search)

	useEffect(() => {
		if (facility) {
			setFormData({ ...formData, ['facility_id']: facility })
		}
	}, [EMPTY_ARRAY, facility])

	useEffect(() => {
		getVehical()
	}, [EMPTY_ARRAY])

	useEffect(() => {
		if (!formData?.facility_id) {
			localStorage.removeItem('facility')
		}
		setFormData({ ...formData, ['zone']: 'A' })
		localStorage.setItem('zone', formData?.zone ? formData?.zone : 'A')


		if (formData?.facility_id || facility) {
			retrievePermitData(formData?.license_number, formData?.facility_id)
		}
		if (formData?.permit_type) {
			const selectedPermit = permitList?.filter((item) => item?.id == Number(formData?.permit_type))
			setPermitTypes(selectedPermit)
		}
		if (formData?.license_number) {
			// const userData = localStorage.getItem('userData') ? localStorage.getItem('userData') : '{}'
			// const user = JSON.parse(userData)
			// const license_number = user?.user?.license_number
			// const handlingLicenseChange = {
			// 	target: {
			// 		value: isLoggedIn() ? license_number : formData?.license_number
			// 	}
			// }
			// handleLicenceNumberChange(handlingLicenseChange)
		}
		setPage('driver')
		dispatch(getFacilityList(partner)).then((res) => {
			setFaclityList(res)
			if (res?.length == 1) {
				setSelectedFacilty(res?.[0])
				localStorage.setItem('facility', JSON.stringify(res?.[0]))
				setFormData({ ...formData, ['facility_id']: res?.[0]?.id })
				const getAccessPermissionData = sortPortalPermissionByKey(partnerDetails, 'Restricted Permissions')
				if (!isPermissionExist(getAccessPermissionData, 'Driving License')) {
					retrievePermitData(formData?.license_number, res?.[0]?.id)
				} else {
					retrievePermitData('', res?.[0]?.id)
				}
			} else {
				const selFaclity = res?.filter((item) => item?.id == Number(formData?.facility_id || facility))
				setSelectedFacilty(selFaclity?.[0])
				localStorage.setItem('facility', JSON.stringify(selFaclity?.[0]))
				setFormData({ ...formData, ['facility_id']: selFaclity?.[0]?.id })
				const getAccessPermissionData = sortPortalPermissionByKey(partnerDetails, 'Restricted Permissions')
				if (!isPermissionExist(getAccessPermissionData, 'Driving License')) {
					retrievePermitData(formData?.license_number, selFaclity?.[0]?.id)
				} else {
					retrievePermitData('', selFaclity?.[0]?.id)
				}
			}
			// if (formData?.facility_id) {
			// 	const selFaclity = res?.filter((item) => item?.id == Number(formData?.facility_id))
			// 	if (selFaclity?.[0] && selFaclity?.[0]?.full_name != '') {
			// 		setSelectedFacilty(selFaclity?.[0])
			// 		localStorage.setItem('facility', JSON.stringify(selFaclity?.[0]))
			// 	}
			// } else {
			// // setSelectedFacilty(res?.[0])
			// 	localStorage.setItem('facility', JSON.stringify(res?.[0]))
			// 	if (res?.[0]?.id) {
			// 		retrievePermitData('', res?.[0]?.id)
			// 	}
			// }
		})
		if (isLoggedIn()) {
			const userData = localStorage.getItem('userData')
			const user = JSON.parse(userData)
			// save loginUserData
			// setLoginData(user?.user)
			const license_number = user?.user?.license_number ? user?.user?.license_number : formData?.license_number

			formData['license_number'] = license_number
			formData['driver'] = driverList
			setFormData({ ...formData })

			// if ((vehicles?.length > 0 && vehicles[0]?.license_plate != '') && !formData?.vehicleSelected) {
			// 	// dougth full change vehcle table true kiya hai
			// 	// setIsVehicleTableVisible(false)
			// } else {
			// 	setIsVehicleTableVisible(true)
			// }
			if (VehiclePrev) {
				dispatch(getVehicleDataList()).then((res) => {
					let payloadData = { ...formData }
					let vehicleCopy = []
					res?.data?.map((value) => {
						let copy = { ...value }
						let modelData = vehicleDetailsList?.make?.filter((v) => v.name == copy?.make)
						let modelList = (modelData?.length != 0 ? modelData?.[0]?.mst_model : [])
						let filteredmakemodelList = modelList?.filter((v) => v.name == copy?.model)
						// // setvehicleModelList(modelData?.[0]?.mst_model)
						let check = modelList?.some((value) => value?.name == 'Others')
						if (!check && modelList != undefined) {
							modelList.unshift({
								'id': 'Others',
								'make_id': 'Others',
								'name': 'Others'
							})
						}
						copy['license_plate'] = copy?.license_plate_number
						copy['maketext'] = copy?.make ? copy?.make : ''
						copy['make'] = modelData?.length == 0 ? 'Others' : copy?.make ? copy?.make : ''
						copy['othermake'] = modelData?.length == 0 ? true : false
						copy['othermodel'] = filteredmakemodelList?.length == 0 ? true : false
						copy['modeltext'] = copy?.model ? copy?.model : ''
						copy['model'] = filteredmakemodelList?.length == 0 ? 'Others' : copy.model ? copy?.model : ''
						copy['vehicleList'] = modelList != undefined ? modelList : vehicleModelList
						copy['is_modal_show'] = is_modal_show || false
						delete copy['license_plate_number']
						vehicleCopy.push(copy)
					})
					payloadData['vehicleList'] = vehicleCopy
					setvehicleCount(vehicleCopy.length)
					setvehicleCountList(vehicleCopy)
					setFormData(payloadData)
					if (partner == 'menlo') {
						const filterVehicle = vehicleCopy?.filter((vehicle) => vehicle?.is_default == 1)
						setVehicleListArray((filterVehicle && filterVehicle?.length > 0) ? filterVehicle : vehicleCopy[0] ? [vehicleCopy[0]] : vehicleListArray)
					} else {
						setVehicleListArray((vehicleCopy && vehicleCopy?.length > 0) ? vehicleCopy : vehicleListArray)
					}
					let selectedVehicles = selectedVehicleList?.slice() ?? []
					let vehicleArrayList = selectedVehicles?.length > 0 ? selectedVehicles : [createDefaultVehicle(partnerDetails?.facilities?.[0]?.country_code, true)]
					setSelectedVehicleList(vehicleCopy?.length > 0 ? EMPTY_ARRAY : vehicleArrayList)
					if (res?.data?.length == 5) {
						// dougth full change vehcle table true kiya hai
						// setIsVehicleTableVisible(false) 
						// setIsVehicleTableVisible(true)
					} else {
						// setIsVehicleTableVisible(true)
					}
				})
			}
		} else {
			let selectedVehicles = selectedVehicleList?.slice() ?? []
			let vehicleArrayList = selectedVehicles?.length > 0 ? selectedVehicles : [createDefaultVehicle(partnerDetails?.facilities?.[0]?.country_code, true)]
			setSelectedVehicleList(vehicleArrayList)
		}
	}, [vehicleDetailsList])



	useEffect(() => {
		if (partner && partner != 'navigating') {
			if (partner == 'worldport-la') {
				navigate(`/${partner}${URL?.BASE_RESPONSIVE_RESERVATION}`)
			}
		}
	}, [EMPTY_ARRAY, partner])

	useEffect(() => {
		const getAccessPermissionData = sortPortalPermissionByKey(partnerDetails, 'Restricted Permissions')
		setAccessPermissions(getAccessPermissionData)
	}, [EMPTY_ARRAY, partnerDetails])

	useEffect(() => {
		if (formData?.permit_type) {
			const selectedPermit = permitList?.filter((item) => item?.id == Number(formData?.permit_type))
			setPermitTypes(selectedPermit)
		}
	}, [EMPTY_ARRAY, permitList])

	const addNewDriver = () => {
		const driverListcopy = driverList.slice()
		const emptyDriver = driverList?.filter((item) => item?.driver_name == '')
		if (emptyDriver?.length > 0) {
			//alert('Add driver name')
			setFormError('driver')
		} else {
			driverListcopy.push({ 'driver_name': '', 'driver_signature': '', 'signature_name': '' })
			setdriverList(driverListcopy)
		}

	}
	const removeDriverImage = (i) => {
		let driverListcopy = [...driverList]
		driverListcopy.forEach(obj => {
			obj.driver_signature = ''
			obj.signature_name = ''
		})
		document.getElementById(`driver_signature_${i}`).value = ''
		setdriverList(driverListcopy)
	}
	const removeDriver = (i) => {
		const driverListcopy = driverList.slice()
		driverListcopy?.splice(i, 1)
		setdriverList(driverListcopy)
	}

	useEffect(() => {
		let driverData = { ...formData }
		driverData['driver'] = driverList
		setFormData(driverData)
	}, [driverList])


	const getVehical = () => {
		dispatch(getVehicleModelList(partnerDetails?.facilities?.[0]?.country_code)).then((res) => {
			let makeList = res?.make
			// To identify if the model is available or not 
			const allHaveMst_model = makeList?.every(makeObj => Object.hasOwn(makeObj, 'mst_model')) ?? false
			if (allHaveMst_model) {
				makeList?.unshift({ 'id': 'Others', 'name': 'Others', 'mst_model': [{ 'id': 'Others', 'make_id': 'Others', 'name': 'Others' }] })
			}
			setVehicleMakeList(makeList)
			setVehicleDetailsList(res)
			setMainVehicleMakeList(makeList)

			// to add a key related to show the modal
			const vehicleData = vehicleListArray.map(item => ({ ...item, is_modal_show: allHaveMst_model }))
			// to set this in local to manage model on other files
			localStorage.setItem('allHaveMst_model', JSON.stringify(allHaveMst_model))
			setVehicleListArray(vehicleData)
			setIsShowModalInVehicle(allHaveMst_model)
			// setValue('country', res.country[0].name)
			// if (BookingEdit) {
			// 	let model = (res?.make?.length > 0) && res?.make?.filter((v) => v?.name == BookingEditData?.vehical_details?.make)
			// 	setvehicleModelList(model[0]?.mst_model)
			// }

		})

	}


	// useEffect(() => {
	// 	permitList
	// 	const selectedPermit = faclityList?.filter((item) => item?.id == Number(value))
	// 	setPermitTypes()
	// }, [EMPTY_ARRAY, permitList])

	const retrievePermitData = (license_number, facility_id) => {
		if (facility_id) {
			const permitPayload = {
				'facility_id': facility_id,
				'is_promotion': promotion && promotion != '' && promotion == 'permittype2' ? '1' : searchParams?.get('permitID') ? '1' : '0',
				'driving_license': !isPermissionExist(accessPermissions, 'Driving License') ? license_number ? license_number?.trim() : '' : ''
			}
			// if (validLicenceNumber.test(license_number?.trim())) {
			dispatch(permitRateList(permitPayload)).then((res) => {
				if (res?.data?.length == 1) {
					setFormData({ ...formData, ...{ permit_type: res?.data[0]?.id }, facility_id: facility_id, 'permit_type_name': res?.data?.[0]?.name ? res?.data?.[0]?.name : '' })
				}
				setPermit(res?.data)

			})
		}

	}

	// const deb = useCallback(
	// 	debounce((license_number, facility_id) => {
	// 		retrievePermitData(license_number, facility_id)
	// 	}, 300),
	// 	[])

	// const handleLicenceNumberChange = (e) => {
	// 	const { value } = e.target
	// 	if (value?.length > 6 && value?.length < 14) {
	// 		if (value?.length != 9) {
	// 			if (validLicenceNumber.test(value?.trim())) {
	// 				const licenseData = {
	// 					resident: 'Non-Resident',
	// 					license_number: value?.toUpperCase()
	// 				}
	// 				setResident('Non-Resident')

	// 				setFormData({ ...formData, ...licenseData })
	// 			} else {
	// 				const licenseData = {
	// 					resident: '',
	// 					license_number: value?.toUpperCase()
	// 				}
	// 				setFormData({ ...formData, ...licenseData })
	// 				setResident('Invalid License Number')
	// 			}
	// 		} else {
	// 			const alpha = value?.slice(0, 1)
	// 			const number = value?.slice(1, 9)
	// 			if (/^[H]+$/.test(alpha) && /(\d{8})/g.test(number)) {
	// 				const licenseData = {
	// 					resident: 'Resident',
	// 					license_number: value?.toUpperCase()
	// 				}
	// 				setFormData({ ...formData, ...licenseData })
	// 				setResident('Resident')
	// 			} else {
	// 				if (validLicenceNumber.test(value?.trim())) {
	// 					const licenseData = {
	// 						resident: 'Non-Resident',
	// 						license_number: value?.toUpperCase()
	// 					}
	// 					setFormData({ ...formData, ...licenseData })
	// 					setResident('Non-Resident')
	// 				} else {
	// 					const licenseData = {
	// 						resident: '',
	// 						license_number: value?.toUpperCase()
	// 					}
	// 					setFormData({ ...formData, ...licenseData })
	// 					setResident('Invalid License Number')
	// 				}
	// 			}
	// 		}
	// 		// Call Debounce
	// 		deb(value, formData?.facility_id)
	// 	} else {
	// 		const licenseData = {
	// 			resident: '',
	// 			license_number: value?.toUpperCase()
	// 		}
	// 		setFormData({ ...formData, ...licenseData })
	// 		setResident('')
	// 	}
	// }

	const handleInputFieldsData = (e, i) => {
		const { name, value } = e.target
		let vehicleList = selectedVehicleList?.slice() ?? []
		if (name == 'color') {
			let colorData = vehicleDetailsList?.color?.filter((v) => v.name == value)
			vehicleList[i]['color'] = colorData?.[0]?.name
			vehicleList[i]['color_id'] = colorData?.[0]?.id
			setSelectedVehicleList(vehicleList)
		} else if (name == 'vehicle_type') {
			let vehicletypeData = vehicleDetailsList?.vehicletype?.filter((v) => v?.name === value)
			vehicleList[i]['vehicle_type'] = vehicletypeData?.[0]?.name ?? ''
			vehicleList[i]['vehicle_type_id'] = vehicletypeData?.[0]?.id ?? ''
			setSelectedVehicleList(vehicleList)
		} else if (name === 'license_plate' || name == 'modeltext' || name == 'maketext' || name == 'state_id' || name == 'vehicle_number') {
			if (name == 'state_id') {
				let stateData = vehicleDetailsList?.state?.filter((v) => v.id == value)
				vehicleList[i]['state_code'] = stateData?.[0]?.state_code
			}
			vehicleList[i][name] = value
			if (name === 'license_plate') {
				vehicleList[i][name] = restrictInValidCharLicense(value)?.replace(/[^a-zA-Z0-9]/g, '')
			} else {
				vehicleList[i][name] = value?.replace(/[^a-zA-Z0-9]/g, '')
			}
			setSelectedVehicleList(vehicleList)
		} else if (name === 'facility_id') {
			const selFaclity = faclityList?.filter((item) => item?.id == Number(value))
			setSelectedFacilty(selFaclity?.[0])
			setFormData({ ...formData, 'facility_id': value })

			if (selFaclity?.[0]) {
				retrievePermitData(formData?.license_number, value)
				localStorage.setItem('facility', JSON.stringify(selFaclity?.[0]))
			} else {
				localStorage.setItem('facility', '{}')
			}
		} else if (name == 'permit_type') {
			const selectedPermit = permitList?.filter((item) => item?.id == Number(value))
			setPermitTypes(selectedPermit)
			const updatedData = { ...formData, [name]: value, 'permit_rate': selectedPermit?.[0]?.permit_rate?.[0]?.rate, 'permit_rate_id': selectedPermit?.[0]?.permit_rate?.[0]?.id, 'permit_type_name': selectedPermit?.[0]?.name ? selectedPermit?.[0]?.name : '' }
			setFormData(updatedData)
		} else if (name == 'model') {
			vehicleList[i]['othermodel'] = (value == 'Others') ? true : false
			vehicleList[i][name] = value
			let modelData = vehicleModelList?.filter((v) => v.name == value)
			vehicleList[i]['model_id'] = modelData?.[0]?.id != 'Others' ? modelData?.[0]?.id : ''
			vehicleList[i]['modeltext'] = value == 'Others' ? '' : value
			setSelectedVehicleList(vehicleList)
		} else if (name == 'make') {
			let modelData = vehicleDetailsList?.make?.filter((v) => v?.name == value)
			let modelList = modelData?.[0]?.mst_model
			let makeData = vehicleMakeList?.filter((v) => v?.name == value)
			let check = modelList?.some((value) => value?.name == 'Others')
			if (!check && is_modal_show) {
				// If 'Others' is not in the list, add it to the first position
				modelList?.unshift({ 'id': 'Others', 'make_id': 'Others', 'name': 'Others' })
			} else {
				// If 'Others' exists, find and move it to the first index
				modelList = (modelList?.length > 0) ? modelList?.filter((value) => value?.name !== 'Others') : [] // Remove 'Others' from the list
				modelList.unshift({ 'id': 'Others', 'make_id': 'Others', 'name': 'Others' }) // Add it back at the first index
			}
			setvehicleModelList(modelList)
			vehicleList[i]['model_id'] = ''
			vehicleList[i]['model'] = value == 'Others' ? 'Others' : ''
			vehicleList[i]['modeltext'] = ''
			vehicleList[i]['vehicleList'] = modelList
			vehicleList[i]['make_id'] = makeData?.[0]?.id != 'Others' ? makeData?.[0]?.id : ''
			vehicleList[i][name] = value
			vehicleList[i]['maketext'] = value == 'Others' ? '' : value
			vehicleList[i]['othermake'] = (value == 'Others') ? true : false
			vehicleList[i]['othermodel'] = (value == 'Others') ? true : false
			setSelectedVehicleList(vehicleList)
		} else {
			if (name == 'zone') {
				localStorage.setItem('zone', value)
			}
			setFormData({ ...formData, [name]: value })
		}
	}

	const setPermitTypes = (selectedPermit) => {

		// setResident(selectedPermit?.[0]?.name)
		const permit = selectedPermit?.[0]
		// setPermitPrices(permit)
		const permitRate = permit?.permit_rate?.[0]
		if (permitRate?.name) {
			localStorage.setItem('permits', JSON.stringify(permitRate))
			const permitDetails = {
				permit_rate: permitRate?.rate,
				permit_rate_id: permitRate?.id,
				facility_id: permitRate?.facility_id,
				license_number: formData?.license_number ? formData?.license_number : '',
				permit_type: selectedPermit?.[0]?.id
			}
			setFormData({ ...formData, ...permitDetails })
			// setPermitRateError('')
		} else {
			if (formData?.facility_id) {
				// setPermitRateError('Permit booking is not available for this location.')
			} else {
				// setPermitRateError('')
			}
			localStorage.setItem('permits', '{}')
		}
	}

	const canAddVehicle = (vehicleList = []) => {
		const allFilled = vehicleList.every(item => item?.license_plate !== '')
		const newVehicleAdded = vehicleList?.filter(item => !item?.id) // Check if the vehicle being added doesn't have an ID (new vehicle)
		const limitExceeded = isVehicleLimitExceeded(accessPermissions, (vehicleListArray.length + newVehicleAdded.length), partnerDetails?.max_vehicle)
		return { allFilled, limitExceeded }
	}

	const addVehicle = () => {
		const vehicleList = selectedVehicleList?.slice() ?? []
		const { allFilled, limitExceeded } = canAddVehicle(vehicleList)

		if (!limitExceeded && allFilled) {
			const defaultVehicle = createDefaultVehicle('', is_modal_show)
			const selectedVehicleList = [...vehicleList, defaultVehicle]

			setSelectedVehicleList(selectedVehicleList)
			setError('')
		} else if (!allFilled) {
			setError('Please enter the License plate, before adding a new vehicle!')
		}
	}

	const removeVehicleMake = (e, i) => {
		const updatedList = selectedVehicleList?.slice() ?? []
		const removedVehicle = updatedList[i]

		// Check if this vehicle is in vehicleCountList (based on ID)
		const wasCounted = vehicleCountList?.some(val => val?.id == removedVehicle?.id)
		if (wasCounted) {
			setvehicleCount(prev => prev - 1)
		}

		// Remove the vehicle at index `i`
		updatedList.splice(i, 1)
		const { allFilled } = canAddVehicle(updatedList)
		if (allFilled) {
			setError('')
		}

		setSelectedVehicleList(updatedList)

		// Optionally: hide table if no vehicles remain
		// if (updatedList.length === 0) {
		//   setIsVehicleTableVisible(false)
		// }
	}

	const onVehicleListChange = (selectedList, changedObject) => {
		const currentList = selectedVehicleList?.slice() ?? []
		// CASE 1: Select All / Clear All
		if (!changedObject) {
			// Make sure all selectedList items have valid IDs
			const hasOnlyValidIds = selectedList?.every(v => v?.id !== undefined && v?.id !== null)
			if (!hasOnlyValidIds) return

			const selectedIds = selectedList?.map(v => v?.id)
			const updatedList = currentList?.filter(v => !v?.id || selectedIds?.includes(v?.id))

			// Add any newly selected items not already in currentList
			selectedList?.forEach(v => {
				if (!currentList?.some(c => c.id === v.id)) {
					updatedList.push(v)
				}
			})

			// Sort by id (only for items with id)
			const withId = updatedList.filter(v => v.id !== undefined && v.id !== null)
			const withoutId = updatedList.filter(v => v.id === undefined || v.id === null)

			withId.sort((a, b) => a.id - b.id)
			const finalList = [...withId, ...withoutId]

			setSelectedVehicleList(finalList)
			return
		}

		// Case 2: Single select/deselect
		if (!changedObject?.id) return

		const exists = currentList.some(v => v.id === changedObject.id)

		const updatedList = exists
			? currentList.filter(v => v.id !== changedObject.id) // remove
			: [...currentList, changedObject]                   // add

		// Separate objects with and without id
		const withId = updatedList.filter(v => v.id !== undefined && v.id !== null)
		const withoutId = updatedList.filter(v => v.id === undefined || v.id === null)

		withId.sort((a, b) => a.id - b.id)

		const finalList = [...withId, ...withoutId]

		setSelectedVehicleList(finalList)
	}

	const handleDriverChange = (e, i) => {
		const { name, value } = e.target
		const driverCopy = driverList?.slice()

		if (name == 'driver_name') {
			driverCopy[i][name] = value
		} else if (name == 'driver_signature') {
			let fileInput = false
			let file = e.target.files[0]
			if (file?.size <= 10 * (1048576)) {
				fileInput = file && (file.type === 'image/jpeg' || file.type === 'image/jpg' || file.type === 'image/png')
				if (fileInput) {
					driverCopy[i]['driver_signature'] = e.target.files[0]
					driverCopy[i]['signature_name'] = e.target.files[0]?.name
				} else {
					document.getElementById(`driver_signature_${i}`).value = ''
					notify('error', 'Selected Document is not Valid')
				}
			} else {

				driverList[i].signature_name = ''
				document.getElementById(`driver_signature_${i}`).value = ''
				if (file?.size) {
					notify('error', 'Maximum File Size Exceeded')
				}

			}
		}

		setdriverList(driverCopy)
	}

	return (
		<div className='home-container'>
			<h4 className="text-center my-4 fw-bolder">Driver & vehicle Information</h4>
			<div className=' mt-4'>
				<div className=" align-items-center d-flex justify-content-between mb-2">
					<label className="form-label">Vehicle Information <sup className='text-danger'> *</sup> {(isPermissionExist(accessPermissions, 'Enable Vehicle Limit') && partnerDetails?.max_vehicle > 0) ? <span className='small fw-normal d-block'>Maximum vehicle allowed per permit ({partnerDetails?.max_vehicle})</span> : ''}</label>
					<div className='d-flex gap-1 align-items-center'>
						{((vehicleListArray?.length > 0) && isLoggedIn()) ? <div style={{ minWidth: '200px' }}>
							<MultiSelectInput
								options={vehicleListArray}
								selected={selectedVehicleList?.filter((v) => v?.id)}
								onSelectedChanged={(newSelected, option) => onVehicleListChange(newSelected, option)}
								displayValue="license_plate"
								hasSelectAll={vehicleListArray?.length > 2}
								disableSearch={vehicleListArray?.length < 2}
								overrideStrings={{
									selectSomeItems: 'Select vehicles',
									allItemsAreSelected: 'All vehicles selected',
									countSelected: (count) => `${count} vehicles selected` // or make it dynamic
								}}
							/>
						</div> : null}
						{((vehicleListArray?.length > 0) && isLoggedIn() && (partner !== 'menlo')) ? <span className='text-primary mx-2'>OR</span> : null}
						{partner == 'menlo' ? null : <button
							type='button'
							className='btn btn-primary'
							disabled={canAddVehicle(selectedVehicleList?.slice() ?? [])?.limitExceeded}
							onClick={addVehicle}
						>
							<i className='fa fa-plus me-2'></i> Add New Vehicle
						</button>}
					</div>
				</div>
				<span>Monthly Parking Registration</span>
				{selectedVehicleList?.length > 0 && <div className='table-responsive'>
					<table className={`table mt-2 border table-borderless table-striped table-sm mb-0 small-first-col ${selectedVehicleList?.length > 5 ? 'table-scroll' : ''}`}>
						<thead className='table-light'>
							<tr>
								<th className='small text-muted'>License Plate <span className='text-danger'> *</span></th>
								<th className='small text-muted'>Make</th>
								{is_modal_show ? <th className='small text-muted'>Model</th> : null}
								{isPermissionExist(accessPermissions, 'Get Vehicle Type') ? <th className='small text-muted'>Vehicle Type <span className='text-danger'> *</span></th> : null}
								<th className='small text-muted'>Color</th>
								<th className='small text-muted'>State/Province</th>
								{isPermissionExist(accessPermissions, 'Vin Number') ? <th className='small text-muted' title='Vehicle Identification Number'>VIN</th> : null}
								{selectedVehicleList?.length > 1 ? <th className='small text-muted action-column'>Action</th> : null}
							</tr>
						</thead>
						<tbody className='body-half-screen'>
							{selectedVehicleList?.map((vehicleListItem, vehicleListIndex) => {
								if (vehicleListItem?.id) {
									return (
										<tr key={vehicleListIndex}>
											<td className='small'>{vehicleListItem?.license_plate || '-'}</td>
											<td className='small'>{vehicleListItem?.make || '-'}</td>
											{is_modal_show ? <td className='small'>{vehicleListItem?.model || '-'}</td> : null}
											{isPermissionExist(accessPermissions, 'Get Vehicle Type') ? <td className='small'>{vehicleListItem?.vehicle_type || '-'}</td> : null}
											<td className='small'>{vehicleListItem?.color || '-'}</td>
											<td className='small'>{vehicleListItem?.state_code || '-'}</td>
											{isPermissionExist(accessPermissions, 'Vin Number') ? <td className='small'>{vehicleListItem?.vehicle_number || '-'}</td> : null}
											<td className='small action-column'>
												<a type="button" className="small p-1 border-none text-danger text-white"
													onClick={(e) => removeVehicleMake(e, vehicleListIndex)}
												><i className='fa fa-trash'></i></a>
											</td>
										</tr>
									)
								} else {
									return (
										<tr key={vehicleListIndex} className='bg-light border'>
											<td>
												<TextInput
													type="text"
													name='license_plate'
													className="form-control form-control-sm"
													placeholder="License Plate"
													maxLength={10}
													minLength={1}
													value={vehicleListItem?.license_plate}
													onChange={(e) => handleInputFieldsData(e, vehicleListIndex)}
													aria-describedby="licenseplate"
													spaceNotAllowed={true}
												/>
												<span className="form-text small text-danger">{formError == 'home' && !selectedVehicleList?.[vehicleListIndex]?.license_plate != '' ? 'This field is required' : (selectedVehicleList?.[vehicleListIndex]?.license_plate != '' && selectedVehicleList?.[vehicleListIndex]?.license_plate.length < 2) ? 'Minimum 2 characters allowed' : ''}</span>
											</td>
											<td>
												{vehicleListItem?.othermake ? <div className="position-relative">
													<input
														type="text"
														name='maketext'
														label="Make"
														className="form-control form-control-sm"
														placeholder="Make"
														required={true}
														onChange={(e) => handleInputFieldsData(e, vehicleListIndex)}
														maxLength={15}
														minLength={0}
														onKeyDown={restrictSpecialChar}
														value={vehicleListItem?.maketext}
														aria-describedby="color" />
													<i
														className='fa fa-times position-absolute top-50 end-0 translate-middle-y me-2'
														onClick={() => {
															const vehicleList = [...selectedVehicleList]
															vehicleList[vehicleListIndex]['model_id'] = ''
															vehicleList[vehicleListIndex]['model'] = ''
															vehicleList[vehicleListIndex]['modeltext'] = ''
															vehicleList[vehicleListIndex]['vehicleList'] = []
															vehicleList[vehicleListIndex]['make_id'] = ''
															vehicleList[vehicleListIndex]['make'] = ''
															vehicleList[vehicleListIndex]['maketext'] = ''
															vehicleList[vehicleListIndex]['othermake'] = false
															vehicleList[vehicleListIndex]['othermodel'] = false
															setSelectedVehicleList(vehicleList)
														}}
													></i>
												</div> :
													<select autoComplete="off" name="make" placeholder="Make" onKeyDown={restrictSpecialChar} className="form-select form-select-sm" value={vehicleListItem?.make} id="make" onChange={(e) => handleInputFieldsData(e, vehicleListIndex)}>
														<option value="">Select Make</option>
														{(vehicleMakeList?.length > 0) && vehicleMakeList?.map((val, index) => {
															return (
																<option value={val?.name} key={index} >{val?.name}</option>
															)
														})}
													</select>}
											</td>
											{is_modal_show ? <td>
												<div>
													{(vehicleListItem?.othermake || vehicleListItem?.othermodel) ? <div className="position-relative">
														<input
															type="text"
															name='modeltext'
															className="form-control form-control-sm"
															placeholder="Model"
															onChange={(e) => handleInputFieldsData(e, vehicleListIndex)}
															maxLength={15}
															minLength={4}
															onKeyDown={restrictSpecialChar}
															value={vehicleListItem?.modeltext}
															aria-describedby="model" />
														{!vehicleListItem?.othermake ? <i
															className='fa fa-times position-absolute top-50 end-0 translate-middle-y me-2'
															onClick={() => {
																const vehicleList = [...selectedVehicleList]
																vehicleList[vehicleListIndex]['othermodel'] = false
																vehicleList[vehicleListIndex]['model'] = ''
																vehicleList[vehicleListIndex]['model_id'] = ''
																vehicleList[vehicleListIndex]['modeltext'] = ''
																setSelectedVehicleList(vehicleList)
															}}
														></i> : null}
													</div> :
														<select className='form-select form-select-sm' value={vehicleListItem?.model} placeholder="Model" name="model" id='model' onKeyDown={restrictSpecialChar} onChange={(e) => handleInputFieldsData(e, vehicleListIndex)} disabled={vehicleListItem?.make ? false : true}>
															<option value="0">Select an option</option>
															{(vehicleListItem?.vehicleList?.length > 0) && vehicleListItem?.vehicleList?.map((item, itemIndex) => <option key={(itemIndex + 1)} value={item?.name}>{item?.name}</option>)}
														</select>
													}
												</div>
											</td> : null}

											{isPermissionExist(accessPermissions, 'Get Vehicle Type') ? <td>
												<select name='vehicle_type' autoComplete="off" className='form-select form-select-sm' value={vehicleListItem?.vehicle_type} placeholder="vehicle_type" id='vehicle_type' onChange={(e) => handleInputFieldsData(e, vehicleListIndex)} onKeyDown={restrictSpecialChar}>
													<option value="">Select an option</option>
													{(vehicleDetailsList?.vehicletype?.length > 0) && vehicleDetailsList?.vehicletype?.map((item, itemIndex) => <option key={(itemIndex + 1)} value={item?.name}>{item?.name}</option>)}
												</select>
												<span className="form-text small text-danger">{formError == 'driver' && !selectedVehicleList?.[vehicleListIndex]?.vehicle_type != '' ? 'This field is required' : ''}</span>
											</td> : null}
											<td>
												<select name='color' autoComplete="off" className='form-select form-select-sm' value={vehicleListItem?.color} placeholder="Color" id='color' onChange={(e) => handleInputFieldsData(e, vehicleListIndex)} onKeyDown={restrictSpecialChar}>
													<option value="">Select an option</option>
													{(vehicleDetailsList?.color?.length > 0) && vehicleDetailsList?.color?.map((item, itemIndex) => <option key={(itemIndex + 1)} value={item?.name}>{item?.name}</option>)}
												</select>
											</td>
											<td>
												<select className='form-select form-select-sm' value={vehicleListItem?.state_id} placeholder="State" name="state_id" id='state_id' onKeyDown={restrictSpecialChar} onChange={(e) => handleInputFieldsData(e, vehicleListIndex)}>
													<option value="0">Select an option</option>
													{(vehicleDetailsList?.state?.length > 0) && vehicleDetailsList?.state?.map((item, itemIndex) => <option key={(itemIndex + 1)} value={item?.id} selected={item?.id == selectedVehicleList?.[vehicleListIndex]?.state_id}>{item?.state_code}</option>)}
												</select>
											</td>
											{isPermissionExist(accessPermissions, 'Vin Number') ? <td>
												<TextInput
													disabled={vehicleCount > vehicleListIndex}
													type="text"
													name='vehicle_number'
													className="form-control form-control-sm"
													placeholder="VIN"
													onChange={(e) => handleInputFieldsData(e, vehicleListIndex)}
													maxLength={20}
													minLength={17}
													onKeyDown={restrictSpecialChar}
													value={vehicleListItem?.vehicle_number}
													aria-describedby="vehicle_number"
												/>
											</td> : null}
											{selectedVehicleList?.length > 1 ? <td className='action-column'>
												<a type="button" className="small p-1 border-none text-danger text-white" onClick={(e) => removeVehicleMake(e, vehicleListIndex)}><i className='fa fa-trash'></i></a>
											</td> : null}
										</tr>
									)
								}
							})}
						</tbody>

					</table>
				</div>}
				<small className='text-danger '>{error}</small>
			</div>
			{/* Hide the facility details for diamond */}

			{selectedFaclity?.full_name &&
				<>
					<div className='d-flex my-2 align-items-center justify-content-between'>
						<b className="mb-0 ">Authorized Drivers</b>
						<button
							disabled={driverList?.length >= 3}
							type="button"
							className="btn btn-primary"
							// onClick={vehicleListArray?.length >= 3 ? '' : addNewDriver}
							onClick={() => addNewDriver()}>
							<i className="fa fa-plus"></i> Add Driver
						</button>
					</div>

					<div className='d-none d-sm-block'>
						<div className='row g-0  gap-3 mb-2 border-top pt-2'>
							<div className='col-sm-5 col-md-4'>
								<label colSpan={2}>Authorised Driver Name <span className='text-danger'> *</span></label>

							</div>
							<div className='col-sm-5 col-md-4'>
								<label colSpan={2}>Authorised Driver Document</label>
							</div>

						</div>
					</div>

					{driverList?.length > 0 && driverList?.map((driver, driverindex) => {
						return (
							<div className='row  g-0 gap-3 border-bottom' key={driverindex}>

								<div className=' col-md-4' >
									<label className='d-block d-sm-none' >Authorised Driver Document</label>
									<input
										autoComplete="off"
										value={driver?.driver_name}
										id="driver_name"
										title="Driver Name"
										name='driver_name'
										className="form-control"
										placeholder="Driver Name"
										maxLength="100"
										required=''
										onChange={(e) => { handleDriverChange(e, driverindex) }}
									// onKeyPress={(e) => restrictSpecialChar(e)}
									// onChange={(e) => { field.onChange(e); removeSpecialChar(e) }}
									/>
									<span className="form-text text-danger ">{formError == 'driver' && !driverList?.[driverindex]?.driver_name != '' ? 'This field is required' : ''}</span>
								</div>
								<div className='col-md-4 col-8'>
									<label className='d-block d-sm-none ' >Authorised Driver Document</label>
									<div className='position-relative'>
										<input accept='image/png, image/jpeg,image/jpg' className="form-control" name={'driver_signature'} type="file" id={`driver_signature_${driverindex}`} onChange={(e) => { handleDriverChange(e, driverindex) }} />
										<label
											style={{
												position: 'absolute',
												top: '1px',
												left: '100px',
												padding: '3px',
												background: '#fff'
											}} htmlFor="validatedCustomFile"
										>
											{driver?.signature_name?.length > 25 ? driver?.signature_name?.slice(0, 15) + '...' + driver?.signature_name?.slice(-10) : driver?.signature_name}
										</label>
										{driver?.signature_name ? <button style={{
											position: 'absolute',
											top: '0px',
											right: '0px',

										}} type='button' className='text-danger border-0 btn p-1 '><i className=' fa fa-times' onClick={() => removeDriverImage(driverindex)}></i></button> : ''}

									</div>
									<p className='text-muted small'> File type : (jpeg, jpg, png),  File Size : (10MB)</p>
								</div>

								{driverList?.length > 1 ? <div className='col-sm mt-sm-0 mt-4 col-3'><button type='button' className='btn btn-danger btn-sm'><i className=' fa fa-minus' onClick={() => removeDriver(driverindex)}></i></button>	</div> : ''}

							</div>
						)
					})}

					<small className=' text-muted mb-2'>Note:
						This Vehicle will not be released to any other Individual without a letter of authorization signed by the monthly applicant.
					</small>
				</>
			}
		</div>
	)
}

Driver.propTypes = {
	dispatch: PropTypes.func,
	data: PropTypes.object,
	events: PropTypes.object,
	loader: PropTypes.bool,
	getCard: PropTypes.func,
	passData: PropTypes.object,
	setPage: PropTypes.func,
	setIdProof: PropTypes.func,
	front: PropTypes.string,
	back: PropTypes.string,
	idProof: PropTypes.object,
	formData: PropTypes.object,
	setFormData: PropTypes.func,
	formError: PropTypes.oneOfType([PropTypes.string, PropTypes.bool]),
	partnerDetails: PropTypes.object,
	vehicleListArray: PropTypes.array,
	setVehicleListArray: PropTypes.func,
	setvehicleCount: PropTypes.func,
	vehicleCount: PropTypes.number,
	VehiclePrev: PropTypes.bool,
	notify: PropTypes.func,
	setFormError: PropTypes.string,
	setMainVehicleMakeList: PropTypes.func,
	selectedVehicleList: PropTypes.array,
	setSelectedVehicleList: PropTypes.func
}

Driver.defaulProps = {
	dispatch: noop,
	data: EMPTY_OBJECT,
	events: EMPTY_OBJECT,
	loader: PropTypes.bool,
	getCard: PropTypes.func,
	passData: EMPTY_ARRAY,
	setPage: noop,
	setIdProof: noop,
	front: undefined,
	back: undefined,
	idProof: EMPTY_OBJECT,
	formData: EMPTY_OBJECT,
	setFormData: noop,
	formError: undefined,
	partnerDetails: EMPTY_OBJECT,
	vehicleListArray: EMPTY_ARRAY,
	setVehicleListArray: EMPTY_ARRAY,
	setvehicleCount: noop,
	vehicleCount: PropTypes.number,
	VehiclePrev: PropTypes.bool,
	notify: noop,
	setFormError: undefined,
	setMainVehicleMakeList: noop
}

function mapStateToProps({ basicInfoReducer }) {
	return {
		loader: basicInfoReducer?.loader,
	}
}
export default connect(mapStateToProps)(Driver)